var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"App animated fadeIn",attrs:{"id":"app"}},[_c('TheMaskWindow',{on:{"click":_vm.closeRechargesApp}}),_c('TheAppContainer',[_c('TheHeader'),_c('router-view',_vm._b({},'router-view',_vm.globalProps,false))],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }